import { HistoryOutlined, LockOutlined, MailOutlined } from "@ant-design/icons";
import { t, Trans } from "@lingui/macro";
import { Checkbox, Col, Form, Input, Row } from "antd";
import React, { useEffect, useRef } from "react";
// import { useSelector } from "react-redux";
import { CookieKey } from "../../../enums/CookieKey";
import { CookiesHelper } from "../../../helpers/CookiesHelper";
import Hotkeys from "react-hot-keys";

export default function ModalContent({form, handleOk, user, isModalVisible}) {
    // const sessionReady = useSelector(state => state.Auth.sessionReady);
    const initialEmail = user.email || CookiesHelper.getCookie(CookieKey.last_logged_in_email);

    const passwordInputRef = useRef(null);
    useEffect(() => {
        if (isModalVisible && passwordInputRef.current)
            passwordInputRef.current.focus();
    }, [isModalVisible]);

    return (
        <Row className="modal__session-inactive-row">
            <Hotkeys
                keyName="enter"
                onKeyDown={keyName => {
                    switch (keyName) {
                        case "enter":
                            handleOk();
                            return null;
                        default:
                            return null;
                    }
                }}
                filter={() => true}
            >

                <Col className="modal-icon-col flex-center" span={24}>
                    <HistoryOutlined />
                </Col>
                <Col className="modal-text-col flex-center" span={24}>
                    <h2><Trans>Your session has expired.</Trans></h2>
                    <Trans>Please login again to resume your session.</Trans>
                </Col>
                <Col className="modal-form-col flex-center" span={24}>
                    {/* To reset form after modalDestroy : https://ant.design/components/modal#note */}
                    <Form
                        preserve={false}
                        form={form}
                        onKeyDown={e => {
                            if (e.key === "Enter")
                                handleOk();
                        }}
                        onFinish={handleOk}
                    >
                        <Row gutter={[8, 8]}>
                            <Col span={24}>
                                <Form.Item
                                    name="email"
                                    initialValue={initialEmail}
                                    rules={[
                                        {
                                            type: 'email',
                                            message: t`Please enter a valid email address.`,
                                        }]}
                                >
                                    <Input
                                        prefix={<MailOutlined />}
                                        disabled={initialEmail}
                                        placeholder={t`Email`}
                                    />
                                </Form.Item>
                                <Form.Item
                                    name="password"
                                    rules={[{
                                        required: true,
                                        message: t`Password is required to validate`,
                                    }]}
                                >
                                    <Input.Password
                                        prefix={<LockOutlined />}
                                        placeholder={t`Password`}
                                        allowClear
                                        // autofocus issue: https://github.com/ant-design/ant-design/issues/8668
                                        ref={input => {
                                            if (input)
                                                passwordInputRef.current = input;
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item
                                    className="bottom-clear"
                                    name="remember"
                                    valuePropName="checked"
                                >
                                    <Checkbox>
                                        <Trans>Remember me for 7 days</Trans>
                                    </Checkbox>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Hotkeys>
        </Row>
    );
}
